import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pounds'
})
export class AppPoundsPipe implements PipeTransform {

  transform(
    value: number
  ): string | null {
    return formatPounds(value);
  }
}

export function formatPounds(value: any) {
  value = Math.floor(Number(value));

  return formatCurrency(
    value,
    'en',
    getCurrencySymbol('GBP', 'wide'),
    'GBP',
    '1.0-0'
  );
}